var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-checkout-step-shipping-contacts-messenger"},[_c('ui-form',{attrs:{"model":_vm.fields,"submit-handler":_vm.submitHandler},on:{"update":_vm.updateFormData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }